/**
 * Created by rcabr on 3/29/2016.
 */
angular.module('global.webServices.factory', [])
    .service('WS', ['$http', '$q', 'Logger', function ($http, $q, Logger) {
        this.previousCallsToServer = {};
        this.cacheMap = {};
        this.requestMap = {}

        this.capitaliseFirstLetter = function (string) {
            if (string == null) {
                return "";
            }
            return string.charAt(0).toUpperCase() + string.slice(1);
        };

        this.callServer = async (serviceName, data, {cache = false, abortPrevious = false, responseType = "json"} = {}) => {
            // noinspection JSUnresolvedVariable
            const serviceUrl = serviceName.match(/^http:|^https:/) ? serviceName : appBaseApiUrl + "/" + serviceName;

            let cacheKey;
            if (cache) {
                cacheKey = JSON.stringify({serviceName: serviceName, serviceUrl: serviceUrl, data: data});
                if (this.cacheMap[cacheKey]) {
                    return this.cacheMap[cacheKey];
                }
            }

            if (!this.requestMap[serviceName]) {
                this.requestMap[serviceName] = [];
            }

            if (abortPrevious) {
                if (this.requestMap[serviceName].length) {
                    for (const request of this.requestMap[serviceName]) {
                        request.resolve();
                    }
                    this.requestMap[serviceName] = [];
                }
            }

            const canceler = $q.defer();
            const requestIndex = this.requestMap[serviceName].push(canceler);
            const response = await $http({
                method: 'POST',
                url: serviceUrl,
                data: JSON.stringify(data),
                responseType: responseType,
                timeout: canceler.promise
            });
            canceler.resolve();
            this.requestMap[serviceName].splice(requestIndex, 1);

            if (cache) {
                this.cacheMap[cacheKey] = response.data;
            }

            return response.data;
        };

        this.call = function (serviceName, data, successCallback, errorCallback, cache, shouldCancelPreviousRequest) {
            var serviceUrl = serviceName.match(/^http:|^https:/) ? serviceName : appBaseApiUrl + "/" + serviceName;
            var paramsName = this.capitaliseFirstLetter(serviceName) + "Params";
            if (shouldCancelPreviousRequest == null) {
                shouldCancelPreviousRequest = false;
            }
            return this.callService(paramsName, serviceUrl, data, successCallback, errorCallback, shouldCancelPreviousRequest, null, false, cache);
        };

        this.callService = function (serviceName, serviceUrl, data, successCallback, errorCallback, shouldCancelPreviousRequest, group, shouldWrapJson, cache) {
            var that = this;
            var cacheKey = JSON.stringify(
                {
                    serviceName: serviceName,
                    serviceUrl: serviceUrl,
                    data: data
                }
            );

            if (cache && that.cacheMap[cacheKey] && successCallback) {
                setTimeout(function () {
                    successCallback(that.cacheMap[cacheKey]);
                }, 0);
                return;
            }

            var previousCalls = this.previousCallsToServer;
            if (shouldCancelPreviousRequest == null) {
                shouldCancelPreviousRequest = true;
            }

            if (shouldWrapJson == null) {
                shouldWrapJson = true;
            }

            if (isEmpty(serviceUrl)) {
                Logger.error("No service url sent.");
                return;
            }

            if (shouldCancelPreviousRequest) {
                if (!isEmpty(previousCalls[serviceName]) && !isEmpty(previousCalls[serviceName]["call"])) {
                    previousCalls[serviceName]["call"].resolve();
                    previousCalls[serviceName] = null;
                }
            }

            if (group != null) {
                for (var key in previousCalls) {
                    if (previousCalls[key] != null && previousCalls[key]["group"] != null) {
                        if (previousCalls[key]["group"] == group) {
                            if (previousCalls[key]["call"] != null) {
                                previousCalls[key]["call"].resolve();
                                previousCalls[key] = null;
                            }
                        }
                    }
                }
            }

            var json = angular.toJson(data);
            if (shouldWrapJson) {
                json = "{ " + serviceName + ": " + json + " }";
            }

            previousCalls[serviceName] = {
                "group": group,
                "call": $q.defer()
            };

            const timeoutPromise = previousCalls[serviceName]["call"].promise;
            return new Promise((resolve, reject) => {
                $http({
                    method: 'POST',
                    url: serviceUrl,
                    data: json,
                    responseType: "json",
                    timeout: timeoutPromise
                }).success(function (success) {
                    if (successCallback) {
                        if (cache) {
                            that.cacheMap[cacheKey] = success;
                        }
                        successCallback(success);
                    } else {
                        resolve(success);
                    }
                }).error(function (error) {
                    if (errorCallback) {
                        errorCallback(error);
                    } else {
                        reject(error);
                    }
                });
            });
        }
    }
    ])

    .factory('Logger', function () {
        return {
            removeArgs: function (args, howMany) {
                var newArgs = [];
                for (var i = 0; i < args.length; i++) {
                    if (i < howMany) {
                        continue;
                    }
                    newArgs.push(args[i]);
                }
                return newArgs;
            },

            pad: function (n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            },

            info: function (message) {
                this.print(message, "INFO", this.removeArgs(arguments, 1));
            },

            error: function (message) {
                this.print(message, "ERROR", this.removeArgs(arguments, 1));
            },

            debug: function (message) {
                this.print(message, "DEBUG", this.removeArgs(arguments, 1));
            },

            print: function (message, level, args) {
                if (level == null) {
                    level = "INFO";
                }
                var d = new Date();
                var month = (d.getMonth() + 1);
                var dayOfMonth = d.getDate();
                var time = this.pad(d.getHours(), 2) + ":" + this.pad(d.getMinutes(), 2) + ":" + this.pad(d.getSeconds(), 2);
                var dateStr = month + "/" + dayOfMonth + " " + time;
                var completeMessage = dateStr + " | " + level + " | " + message + "     ";
                if (window.console && window.console.log) {
                    var functionName = "log";
                    if (level == "ERROR" && window.console.error) {
                        functionName = "error"
                    }

                    if (args.length > 0) {
                        window.console[functionName](completeMessage, args);
                    } else {
                        window.console[functionName](completeMessage);
                    }

                }
            }
        }
    });
